<template>
    <div class="bindtips_popup">
        <p>该账号当前没有绑定游戏账号角色，</p>
        <p>请前往绑定</p>
        <el-button class="bind_btn" type="primary" @click="gotoBind">确定</el-button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        gotoBind() {
            this.$emit('closeModal')
            this.$router.push({name: 'user.bind'})
        }
    },
}
</script>
<style lang="less" scoped>
    .bindtips_popup {
        p {
            text-align: center;
            margin-bottom: 0.5rem;
            font-size: 1.4rem;
        }
        .bind_btn {
            width: 12rem;
            height: 3rem;
            border-radius: 2.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;
            margin: 0 auto;
            margin-top: 2rem;
        }
    }
</style>